export default () => {
  const getIconComponent = (iconPath: string) => {
    // Dynamic imports can't traverse folders, so we use import.meta.glob.
    // The `~/` alias resolves to the consuming app's srcDir at build time,
    // so each app's own `assets/icons/` SVGs are picked up.
    // https://vitejs.dev/guide/features#dynamic-import
    const comps = import.meta.glob('~/assets/icons/**/*.svg')
    const suffix = `/assets/icons/${iconPath}.svg`
    const matchKey = Object.keys(comps).find((key) => key.endsWith(suffix))
    const match = matchKey ? comps[matchKey] : undefined
    if (match && typeof match === 'function') {
      return defineAsyncComponent(() => match() as any)
    }
    return null
  }

  return {
    getIconComponent,
  }
}
